import React from "react";
import { graphql } from "gatsby";
import { HelmetDatoCms } from "gatsby-source-datocms";
import Layout from "../components/layout";
import ArticleHero from "../components/articleHero";
import ArticleImage from "../components/articleImage";
import ArticleBody from "../components/articleBody";
import ArticleBack from "../components/articleBack";
import { Box } from "theme-ui";

const Article = ({ data: { article, blog } }) => {
  return (
    <Layout>
      <HelmetDatoCms seo={article.seoMetaTags} />
      <Box py={7}>
        <ArticleHero
          title={article.title}
          publishedAt={article.meta.firstPublishedAt}
          updatedAt={article.meta.updatedAt}
          i18nPublishedAt={blog.i18nPublishedAt}
          i18nUpdatedAt={blog.i18nUpdatedAt}
          category={article.category}
        />
        <ArticleImage image={article.image} />
        <ArticleBody body={article.body} />
        <ArticleBack />
      </Box>
      {/* <pre>{JSON.stringify(article, null, 2)}</pre> */}
    </Layout>
  );
};

export default Article;

export const query = graphql`
  query ArticleQuery($originalId: String!, $locale: String!) {
    article: datoCmsArticle(originalId: { eq: $originalId }) {
      title
      body
      slug
      locale
      image {
        fluid(maxWidth: 1440) {
          ...GatsbyDatoCmsFluid
        }
      }
      meta {
        firstPublishedAt(locale: $locale, formatString: "dddd D MMM YYYY")
        updatedAt(locale: $locale, formatString: "dddd D MMM YYYY")
      }
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
    blog: datoCmsBlog(locale: { eq: $locale }) {
      i18nPublishedAt
      i18nUpdatedAt
    }
  }
`;
